<div class="mapping-root">
  <div class="canvas-layer">
    <app-rete-canvas
      [entityFields]="entityFields()"
      [viewNodes]="viewNodes()"
      [connections]="connections()"
      [selectedViewNodeId]="selectedViewNodeId()"
      (selectViewNode)="handleSelectViewNode($event)"
      (connectionsChange)="handleConnectionsChange($event)"
      (patchViewNode)="handleViewNodePatch($event)"
      (viewNodeFormulaChange)="handleViewNodeFormulaChange($event)"
    ></app-rete-canvas>
  </div>

  <header class="topbar">
    <div class="title">ViewSchema GUI（マッピング）</div>

    <div class="schema-form" [formGroup]="form">
      <label>
        EntitySchema（catalog）
        <select formControlName="entitySchemaId" [disabled]="loadingCatalog()">
          @for (item of catalogItems(); track item.id) {
            <option [value]="item.id">{{ item.name || item.id }}</option>
          }
        </select>
      </label>

      <label>
        schemaPath（自動反映 / 手動も可）
        <input type="text" formControlName="schemaPath" placeholder="settings/test/entitySchema/..." />
      </label>

      <button type="button" (click)="loadCatalog()" [disabled]="loadingCatalog()">
        {{ loadingCatalog() ? 'カタログ読込中...' : 'カタログ再読込' }}
      </button>
      <button type="button" (click)="loadEntitySchema(form.get('schemaPath')?.value || '')" [disabled]="loadingEntitySchema() || !form.get('schemaPath')?.value">
        {{ loadingEntitySchema() ? '読込中...' : 'schema取得' }}
      </button>
    </div>

    <div class="actions">
      <button type="button" class="btn" (click)="addViewFieldNode()">+ ViewFieldノード</button>
      <button type="button" class="btn" (click)="addLiteral('string')">+ Literal(string)</button>
      <button type="button" class="btn" (click)="addLiteral('number')">+ Literal(number)</button>
      <button type="button" class="btn" (click)="addLiteral('string[]')">+ Literal(string[])</button>
      <button type="button" class="btn" (click)="addComparator('==')">+ Comparator(==)</button>
      <button type="button" class="btn" (click)="addComparator('in')">+ Comparator(in)</button>
      <button type="button" class="btn" (click)="addFormula('iif')">+ Fn(iif)</button>
      <button type="button" class="btn" (click)="addFormula('calc')">+ Fn(calc)</button>
      <button type="button" class="btn" (click)="addFormula('round')">+ Fn(round)</button>
      <button type="button" class="btn danger" (click)="removeSelectedViewFieldNode()" [disabled]="!selectedViewNodeId()">
        選択ノード削除
      </button>
    </div>
  </header>

  <div class="floating-ui">
    @if (entitySchemaError()) {
      <div class="error-banner">{{ entitySchemaError() }}</div>
    }
    @if (catalogError()) {
      <div class="error-banner">{{ catalogError() }}</div>
    }

    @if (showPalette()) {
      <aside class="panel palette">
        <app-entity-field-palette
          [fields]="entityFields()"
          (pickField)="handlePickEntityField($event)"
        ></app-entity-field-palette>
      </aside>
    }

    <aside class="panel right">
      <section class="rowexpands">
        <div class="rowexpands-title">RowExpands</div>
        <div class="rowexpands-hint">チェックした配列項目を行展開します。</div>
        <div class="rowexpands-list">
          @for (f of entityFields(); track f.fieldName) {
            <label class="rowexpand-item">
              <input
                type="checkbox"
                [checked]="rowExpands().includes(f.fieldName)"
                (change)="toggleRowExpand(f.fieldName, ($any($event.target)).checked)"
              />
              <span class="rowexpand-key">{{ f.fieldName }}</span>
            </label>
          }
        </div>
      </section>

      <section class="json-preview">
        <div class="json-title">出力（viewSchema）</div>
        <pre>{{ viewSchemaJson() }}</pre>
      </section>
    </aside>
  </div>
</div>

